import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxNotepad = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 4H16V2H14V4H10V2H8V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4ZM5 20V7H19V6L19.002 20H5Z" fill="currentColor" /><path d="M7 9H17V11H7V9ZM7 13H12V15H7V13Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxNotepad);
export default Memo;